module.exports = __webpack_public_path__ + "static/media/landingCoCreation.5076b920.mp4";